import { TalentIntroductionRow } from "../../types";

const sortTalentIntroductionsByIntroducedAt = (
  introductions: TalentIntroductionRow[],
) => [...introductions].sort((a, b) => a.introducedAt - b.introducedAt);

export default sortTalentIntroductionsByIntroducedAt;
